var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',{attrs:{"value":_vm.value,"attributes":_vm.attr,"input-props":{ class: 'form-control', placeholder: 'Data', id: _vm.id, required: _vm.required, disabled: _vm.disabled, autocomplete: 'off' },"first-day-of-week":1,"popover":{ visibility: 'click' },"locale":"pt-BR"},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }